
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import CompareModal from "@/components/modals/CompareModal.vue";
import Feedback from "@/components/modals/Feedback.vue";
import SaveAsProfileModal from "@/components/modals/SaveAsProfileModal.vue";
import SelectBucketingModal from "@/components/modals/SelectBucketingModal.vue";
import AdminModal from "@/components/modals/AdminModal.vue";
import DeleteProfileModal from "@/components/modals/DeleteProfileModal.vue";
import MultiProductModal from "@/components/modals/MultiProductModal.vue";
import DateSelectModal from "@/components/modals/DateSelectModal.vue";
import SignInEmail from "@/components/modals/SignInEmail.vue";
import NoCompany from '@/components/modals/NoCompany.vue';

@Component({
  components: {
    CompareModal,
    Feedback,
    SaveAsProfileModal,
    SelectBucketingModal,
    AdminModal,
    DeleteProfileModal,
    MultiProductModal,
    DateSelectModal,
    SignInEmail,
    NoCompany
  }
})
export default class Modal extends Vue {
  public suppressClose: string[] = [
    // route names
  ];

  get showingModal() {
    return this.$store.state.general.showingModal;
  }

  get asOfError(): string | undefined {
    return this.$store.state.profiles.asOfError;
  }

  public closeModal() {
    if (this.suppressClose.indexOf(this.showingModal) === -1
      && !this.asOfError
    ) {
      this.$store.commit('setModal', '');
      // Add whatever store cleaning we may need here
    }
  }

  // Prevent body scroll when modal is open
  @Watch('showingModal')
  private onPropertyChanged(value: string, oldValue: string) {
    if (value) {
      const top = `-${window.scrollY}px`;
      document.body.style.position = 'fixed';
      document.body.style.top = top;
    } else {
      const top = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      const scrollY = top;
      window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
    }
  }
}

